module.exports = __webpack_public_path__ + "static/media/amazon.72c940d1.svg";